import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';
import { tabs } from './config';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({}) => {
  return {
    setSelectedIndexfn: {
      [SERVICE_PROVIDERS.SPIREON]: () => ({ rowLen: 36, wl: 104 }),
      default: () => false,
    },
    manageLogsHeader_className: {
      [SERVICE_PROVIDERS.SPIREON]: () => 'sublogwrapper',
      default: () => 'vehicleTabs',
    },
    manageLogsHeader_style: { [SERVICE_PROVIDERS.SPIREON]: () => true, default: () => false },
    driverTabs: {
      [SERVICE_PROVIDERS.SPIREON]: () => tabs.driverTabs[SERVICE_PROVIDERS.SPIREON],
      default: () => tabs.driverTabs['default'],
    },
    tenantTabs: {
      [SERVICE_PROVIDERS.SPIREON]: () => tabs.tenantTabs[SERVICE_PROVIDERS.SPIREON],
      default: () => tabs.tenantTabs['default'],
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
